import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomOverViewPdpIsExpandState from "@tCentro/Store/Reducer/CustomOverViewPdpIsExpandState";

import { Draft } from "immer";

const initialState: CustomOverViewPdpIsExpandState = {
    overViewPdpBlockisExpanded: false,
};

const reducer = {
    "Pages/CENProductDetails/CENOverviewPDPBlockisExpanded": (draft: Draft<CustomOverViewPdpIsExpandState>) => {
        draft.overViewPdpBlockisExpanded = !draft.overViewPdpBlockisExpanded;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
